import React, { useEffect, useState } from "react";
import "./about.css";
import Team from "./Team";
import AboutImg from "../../../asset/new/images/aboutus.png";
import SoniaImg from "./../../../asset/new/images/Sonia Singal.jpeg";
import AboutUs from "./aboutus.png";
import { axiosInstance } from "../../../Axios/AxiosInstance";
import { FaBriefcase, FaBuilding, FaLightbulb, FaUsers } from "react-icons/fa";
import SeoHead from "../../Common/SeoHead";
import { PAGE_SEO } from "../../../constants/seo";

const About = () => {
  const [about, setAbout] = useState();

  // Fetch contact details from API
  useEffect(() => {
    axiosInstance
      .get("about-us")
      .then((response) => {
        setAbout(response?.data?.about);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }, []);

  return (
    <>
      <SeoHead
        title={PAGE_SEO["/about"].title}
        description={PAGE_SEO["/about"].description}
        path="/about"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "About Us", path: "/about" },
        ]}
      />

      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-container">
          <div className="about-hero-grid">
            <div className="about-hero-content">
              <h1 className="about-page-title">About Us</h1>
              <p className="about-hero-text">
                Founded in August 2013 by a group of CAs and IIM Ahmedabad
                graduates, cajobportal.com is India's first recruitment
                website exclusively for finance professionals. Our
                Advisory Board comprises of senior Chartered Accountants
                and IIMA alums including the co-founder and former COO of
                naukri.com.
              </p>
            </div>
            <div className="about-hero-image">
              <img src={about?.about_us_image || AboutImg} alt="About CAJobPortal" />
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="about-mission">
        <div className="about-mission-container">
          <div className="about-mission-grid">
            <div className="about-illustration">
              <img src={about?.illustrate_image || AboutUs} alt="Illustration" />
            </div>
            <div className="about-mission-content">
              <h2 className="about-section-title">
                We Bring Employers and <span className="text-highlight-about">Job Seekers Closer</span>
              </h2>

              <div className="about-services">
                <div className="about-service-item">
                  <div className="service-icon">
                    <FaBriefcase />
                  </div>
                  <div className="service-content">
                    <h3>Featured Jobs</h3>
                    <p>
                      {about?.featured_jobs || "Where we work as search partners for clients and manage the recruitment cycle."}
                    </p>
                  </div>
                </div>

                <div className="about-service-item">
                  <div className="service-icon">
                    <FaBuilding />
                  </div>
                  <div className="service-content">
                    <h3>PSU Jobs</h3>
                    <p>
                      {about?.psu_jobs || "Where we notify candidates on application process for jobs in the government / public sector undertakings."}
                    </p>
                  </div>
                </div>

                <div className="about-service-item">
                  <div className="service-icon">
                    <FaLightbulb />
                  </div>
                  <div className="service-content">
                    <h3>Career Site</h3>
                    <p>
                      {about?.career_site || "Where we re-direct candidates to the open positions on the career site on non-client private sector employers."}
                    </p>
                  </div>
                </div>

                <div className="about-service-item">
                  <div className="service-icon">
                    <FaUsers />
                  </div>
                  <div className="service-content">
                    <h3>Third Party Listings</h3>
                    <p>
                      {about?.third_party_listings || "Where candidates can apply directly on jobs posted by TA teams by creating an employer account on cajobportal.com."}
                    </p>
                  </div>
                </div>
              </div>

              <div className="about-experience">
                <p>
                  {about?.description || (
                    <>
                      We have closed multiple junior, mid-level and senior
                      positions across Treasury, M&A, Risk, Financial
                      Reporting, Costing & Budgeting, Internal Audit, Taxation
                      etc., ranging even up to CFOs level. We also help
                      corporates on-board CA Industrial Trainees.
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="about-testimonial">
        <div className="about-testimonial-container">
          <div className="about-testimonial-card">
            <div className="testimonial-image">
              <img src={about?.sonia_image || SoniaImg} alt="CA Sonia Singal" />
            </div>
            <div className="testimonial-content">
              <div className="testimonial-text">
                {about?.sonia_description || (
                  <>
                    <p>
                      CAJobPortal.com is now trusted by 125+ marquee brands in
                      6 countries, including 50% of BSE-30 companies.
                    </p>
                    <p>
                      Would you like to experience the magic of Cerebral
                      Recruiting?
                    </p>
                  </>
                )}
              </div>
              <div className="testimonial-author">
                <strong>CA. Sonia Singal & Team CAJobPortal.com</strong>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Advisory Team */}
      <section className="about-team">
        <div className="about-team-container">
          <Team />
        </div>
      </section>
    </>
  );
};

export default About;
